import { Sync } from "@mui/icons-material";
import { Typography, Button, Box } from "@mui/material";
import { Modal } from "components/common/Modal";

interface ClientReactivateModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  updateStatus: (event: string, deactivationReason: string) => Promise<void>;
}

export default function ClientReactivateModal({ open, setOpen, updateStatus }: ClientReactivateModalProps) {
  return (
    <Modal open={open} setOpen={setOpen} width={"683px"}>
      <Box mt={4}>
        <Box sx={{ textAlign: "center" }}>
          <Sync color="primary" sx={{ fontSize: "60px" }} />
          <Typography mt={1} variant="h5" component="h2" fontWeight={800} fontSize={"24px"}>
            Reactivate Client
          </Typography>
          <Typography mt={1} color="text.secondary" fontSize={"16px"} gutterBottom>
            Are you sure you want to reactivate this client? They will be able to access their application again.
          </Typography>
          <Box mt={4} sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}>
            <Button variant="contained" onClick={() => updateStatus("activate", "")}>
              Yes, reactivate
            </Button>
            <Button variant="contained" onClick={() => setOpen(false)}>
              No, go back
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
